import { connect } from 'react-redux';
import { IRootState } from '../../redux/state';
import { IUser } from '../../models';
import SurveyTypesPage from './SurveyTypesPage';
import { bindActionCreators, Dispatch } from 'redux';
import { loadSchemaTypes } from '../../redux/modules/surveyCreator/surveyCreatorCreator';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    schemaTypes: state.surveyCreator.schemaTypelist,
    selectedSurvey: state.surveyCreator.selectedSchema,
    isLoading: state.surveyCreator.isLoading,
    selectedType: state.surveyCreator.selectedType,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      loadSchemaTypes,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyTypesPage);
